import createIcon from '../../createIcon';

/**
 * @component @name NightShelter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0w0IDlWMjFIMjBWOUwxMiAzWk05Ljc1IDEyLjVDMTAuNDQgMTIuNSAxMSAxMy4wNiAxMSAxMy43NUMxMSAxNC40NCAxMC40NCAxNSA5Ljc1IDE1QzkuMDYgMTUgOC41IDE0LjQ0IDguNSAxMy43NUM4LjUgMTMuMDYgOS4wNiAxMi41IDkuNzUgMTIuNVpNMTcgMThIMTZWMTYuNUg4VjE4SDdWMTFIOFYxNS41SDExLjVWMTJIMTVDMTYuMSAxMiAxNyAxMi45IDE3IDE0VjE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NightShelter = createIcon('NightShelter', [
  [
    'path',
    {
      d: 'M12 3L4 9V21H20V9L12 3ZM9.75 12.5C10.44 12.5 11 13.06 11 13.75C11 14.44 10.44 15 9.75 15C9.06 15 8.5 14.44 8.5 13.75C8.5 13.06 9.06 12.5 9.75 12.5ZM17 18H16V16.5H8V18H7V11H8V15.5H11.5V12H15C16.1 12 17 12.9 17 14V18Z',
      key: '1x716o',
    },
  ],
]);

export default NightShelter;
